// removed by extract-text-webpack-plugin
module.exports = {"heading":"_2iXTAoxZ3Sw8YgEHDLjff4","otherOptionsContainer":"vzK-b75sN_5zP2M_SFLRw","dialogContainer":"_2K40xuToI8hlXcAteX42b-","authFormContainer":"_3bultiSKFl9RSd0msZZZ_0"};